'use client';

import '~/utils/polyfills';

import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Box } from 'ui';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

const ShowPdfFile = ({
  file,
  scale,
  loadingText,
}: {
  file?: ArrayBuffer | Blob | string;
  scale?: number;
  loadingText?: string;
}) => {
  const [pages, setNumPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  return (
    <Document file={file} onLoadSuccess={onDocumentLoadSuccess} loading={loadingText}>
      {Array.from(new Array(pages), (_, index) => (
        <Box key={`page_wrapper_${index + 1}`} display="flex" justifyContent="center">
          <Page
            loading={loadingText}
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            scale={scale}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Box>
      ))}
    </Document>
  );
};

export default ShowPdfFile;
